import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
      "stroke-width": "1.5"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      d: "M14 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-5",
      "stroke-width": "1.5"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }